<script setup lang="ts">
import { Button, type ButtonProps } from 'vant';

const props = defineProps<Partial<ButtonProps>>();
</script>

<template>
  <Button v-bind="props" size="small">
    <div :class="$style.content">
      <slot></slot>
    </div>
  </Button>
</template>

<style module>
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 25px;
  min-width: 25px;
}
</style>